import * as React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';

import App from './App';

const Root = ({ store }) => (
	<Provider store={store}>
		<App />
	</Provider>
);

Root.propTypes = {
	store: PropTypes.shape({}),
};

Root.defaultProps = {
	store: null,
};

export default Root;
